import { useState, useEffect } from "react";

import { RESEARCH_TEAM } from "globals/constants/formObjects";

const { ASSOCIATION_TYPE } = RESEARCH_TEAM;

export default function useDisplayConditions (settings, value, isRTObjectRequired) {
	const {
		externalResearchers,
		creditField,
		creditFieldRequired,
		sponsoredEffort,
		sponsoredEffortRequired,
		costShareEffort,
		costShareEffortRequired
	} = settings;

	const [ displayConditions, setDisplayConditions ] = useState({});

	useEffect(() => {
		if (value) {
			const shouldDisplayEffortToggle = (costShareEffort || sponsoredEffort) && value.some(member => member.associationType === ASSOCIATION_TYPE.INTERNAL),
				shouldDisplayTotalCreditReadout = value.some(member => member.associationType === ASSOCIATION_TYPE.INTERNAL) && creditField,
				shouldDisplayTotalEffort = !(!costShareEffort && !sponsoredEffort),
				shouldDisplayAtLeastOneEffortField = (sponsoredEffort || costShareEffort);

			setDisplayConditions({
				shouldDisplayEffortToggle,
				shouldDisplayTotalCreditReadout,
				shouldDisplayTotalEffort,
				shouldDisplayAtLeastOneEffortField,
				creditField,
				sponsoredEffort,
				costShareEffort,
				externalResearchers,
				creditFieldRequired: creditFieldRequired && isRTObjectRequired,
				sponsoredEffortRequired: sponsoredEffortRequired && isRTObjectRequired,
				costShareEffortRequired: costShareEffortRequired && isRTObjectRequired,
				isRequired: isRTObjectRequired,
			});
		}
	}, [ costShareEffort, costShareEffortRequired, creditField, creditFieldRequired, externalResearchers, isRTObjectRequired, sponsoredEffort, sponsoredEffortRequired, value ]);
	return [ displayConditions ];
};